<template>
  <motlet :options="motletOptions">
    <template v-slot:content>
      <v-row style="flex-wrap: nowrap;" class="h-100">
        <v-col v-for="(instance, index) in instances" :key="index" class="flex-grow-1 flex-shrink-0">
          <div class="pa-auto h-100 d-flex align-center justify-center flex-column">
            <v-card @click="selectInstance(index)" class="pa-2" outlined>
              <v-icon large :color="iconColor(index)">mdi-server-network</v-icon>
            </v-card>
            <!--div class="mt-4">{{ instance.id }}</div-->
            <div class="mt-4">{{ instance.shortAlias }}</div>
          </div>
        </v-col>
      </v-row>
    </template>
  </motlet>
</template>

<script>
import instanceable from './mixins/instanceable';

export default {
  mixins: [instanceable],
  data() {
    return {};
  },
  computed: {
    motletOptions() {
      return {
        id: 'overview/system/abap/Event',
        title: this.$t('ov.sys.title.event'),
      };
    },
  },
  methods: {
    iconColor(index) {
      //BEGIN::Modified.by.KWShin.2024.01.11.
      // return this.instances[index].active ? 'orange darken-2' : 'grey darken-2';
      return this.instances[index].active ? this.instances[index].color : 'grey darken-2';
      //FINISH::Modified.by.KWShin.2024.01.11.
    },
    selectInstance(index) {
      if (this.instances[index].active) {
        const allActive = this.instances.every(instance => instance.active);
        if (allActive) this.instances.forEach((instance, seq) => (instance.active = index == seq));
        else this.instances.forEach(instance => (instance.active = true));
      } else {
        this.instances.forEach((instance, seq) => (instance.active = index == seq));
      }
    },
  },
};
</script>
